import script from "./DialogUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogUI.vue?vue&type=script&setup=true&lang=ts"

import "./DialogUI.vue?vue&type=style&index=0&id=63d20d4d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d20d4d"]])

export default __exports__